/**
 * Author: Andrey Morozov
 * Confidential. Proprietary code. Do not distribute without authorization.
 *
 * voiceTransportFactory.ts — voic\1 \2ranspor\1 \2actory (services/operator-web-app).
 */

/**
 * E3-S2: Factory for voice transport (WebSocket vs WebRTC).
 * E3-S2 T1: WebRTC uses SIP.js (SipJsVoiceTransport) for SIP registration and incoming INVITE/accept/BYE.
 */
import { appConfig } from '@/config/env';
import type { CallTransportProfile } from '@/config/featureFlags';
import type { CallVoiceTransportCallbacks, ICallVoiceTransport } from './types';
import { CallVoiceClient } from './CallVoiceClient';
import { SipJsVoiceTransport } from './SipJsVoiceTransport';

export function createVoiceTransport(
  wsCallUrl: string,
  transport: CallTransportProfile,
  callbacks: CallVoiceTransportCallbacks = {}
): ICallVoiceTransport {
  if (transport === 'webrtc') {
    return new SipJsVoiceTransport(
      {
        sipWsUrl: appConfig.sipWsUrl,
        sipDomain: appConfig.sipDomain,
      },
      callbacks
    );
  }
  return new CallVoiceClient(wsCallUrl, callbacks);
}
